export const ColorCodes = [
    {id: 'A5C365', hex: '#A5C365', text: '#fff', rgb: '165, 195, 101'},
    {id: 'FFB062', hex: '#FFB062', text: '#fff', rgb: '255, 176, 98'},
    {id: '65ACC3', hex: '#65ACC3', text: '#fff', rgb: '101, 172, 195'},
    {id: 'F16891', hex: '#F16891', text: '#fff', rgb: '241, 104, 145'},
    {id: 'E569D5', hex: '#E569D5', text: '#fff', rgb: '229, 105, 213'},
    {id: 'FF8B63', hex: '#FF8B63', text: '#fff', rgb: '255, 139, 99'},
    {id: 'D0D04C', hex: '#D0D04C', text: '#fff', rgb: '208, 208, 76'},
    {id: '73CAC2', hex: '#73CAC2', text: '#fff', rgb: '115, 202, 194'},
    {id: 'C39865', hex: '#C39865', text: '#fff', rgb: '195, 152, 101'},
    {id: 'CC7979', hex: '#CC7979', text: '#fff', rgb: '204, 121, 121'}
];

export const ExtendedColorCodes = [
    ...ColorCodes,
    {id: 'A6E176', hex: '#A6E176', text: '#fff', rgb: '166, 225, 118'},
    {id: 'F2CB6D', hex: '#F2CB6D', text: '#fff', rgb: '242, 203, 109'},
    {id: '778FCC', hex: '#778FCC', text: '#fff', rgb: '119, 143, 204'},
    {id: 'FA7171', hex: '#FA7171', text: '#fff', rgb: '250, 113, 113'},
    {id: 'D878F8', hex: '#D878F8', text: '#fff', rgb: '216, 120, 248'},
    {id: 'F19C7F', hex: '#F19C7F', text: '#fff', rgb: '241, 156, 127'},
    {id: 'E2DC32', hex: '#E2DC32', text: '#fff', rgb: '226, 220, 50'},
    {id: '86DCBF', hex: '#86DCBF', text: '#fff', rgb: '134, 220, 191'},
    {id: 'E1B581', hex: '#E1B581', text: '#fff', rgb: '225, 181, 129'},
    {id: 'E28080', hex: '#E28080', text: '#fff', rgb: '226, 128, 128'}
];

export const GrayColorCodes = [
    {id: '888888', hex: '#888888', text: '#fff', rgb: '136, 136, 136'}
];

export const BlackColorCode = [
    {id: '444444', hex: '#444444', text: '#fff', rgb: '68, 68, 68'}
];

// Make sure when adding/deleting icons, it will be synced with API svg_icons.blade.php

export const IconSet = [
    {id: 'mdi-check', library: 'mdi'},
    {id: 'mdi-close', library: 'mdi'},
    {id: 'mdi-account-arrow-left', library: 'mdi'},
    {id: 'mdi-account-group', library: 'mdi'},
    {id: 'mdi-account-multiple', library: 'mdi'},
    {id: 'mdi-account-plus', library: 'mdi'},
    {id: 'mdi-alarm', library: 'mdi'},
    {id: 'mdi-alert', library: 'mdi'},
    {id: 'mdi-arrow-top-left-thick', library: 'mdi'},
    {id: 'mdi-asterisk', library: 'mdi'},
    {id: 'mdi-baby-carriage', library: 'mdi'},
    {id: 'mdi-balloon', library: 'mdi'},
    {id: 'mdi-bell', library: 'mdi'},
    {id: 'mdi-cake-variant', library: 'mdi'},
    {id: 'mdi-camera-account', library: 'mdi'},
    {id: 'mdi-camera', library: 'mdi'},
    {id: 'mdi-cards-heart', library: 'mdi'},
    {id: 'mdi-shape', library: 'mdi'},
    {id: 'mdi-flag', library: 'mdi'},
    {id: 'mdi-ship-wheel', library: 'mdi'},
    {id: 'mdi-chat', library: 'mdi'},
    {id: 'mdi-food-apple', library: 'mdi'},
    {id: 'mdi-circle-slice-6', library: 'mdi'},
    {id: 'mdi-music-note-eighth', library: 'mdi'},
    {id: 'mdi-nature', library: 'mdi'},
    {id: 'mdi-spa', library: 'mdi'},
    {id: 'mdi-forward-arrow', library: 'mdi'},
    {id: 'mdi-star-face', library: 'mdi'},
    {id: 'mdi-nut', library: 'mdi'},
    {id: 'mdi-gift', library: 'mdi'},
    {id: 'mdi-gnome', library: 'mdi'},
    {id: 'mdi-palm-tree', library: 'mdi'},
    {id: 'mdi-panda', library: 'mdi'},
    {id: 'mdi-hand', library: 'mdi'},
    {id: 'mdi-pentagon', library: 'mdi'},
    {id: 'mdi-thumb-up', library: 'mdi'},
    {id: 'mdi-heart', library: 'mdi'},
    {id: 'mdi-pig', library: 'mdi'},
    {id: 'mdi-tooth', library: 'mdi'},
    {id: 'mdi-language-swift', library: 'mdi'},
    {id: 'mdi-rhombus-split', library: 'mdi'},
    {id: 'mdi-fan', library: 'mdi'},
    {id: 'mdi-map-marker', library: 'mdi'}
];

export const AvatarBackgroundColors = [
    {char: 'a', hex: '#A4BD6D', text: '#fff'},
    {char: 'b', hex: '#FFAE65', text: '#fff'},
    {char: 'c', hex: '#6EA9B8', text: '#fff'},
    {char: 'd', hex: '#E46B8D', text: '#fff'},
    {char: 'e', hex: '#DA6BCB', text: '#fff'},
    {char: 'f', hex: '#FF8B65', text: '#fff'},
    {char: 'g', hex: '#C9C957', text: '#fff'},
    {char: 'h', hex: '#72C2BB', text: '#fff'},
    {char: 'i', hex: '#BB9767', text: '#fff'},
    {char: 'j', hex: '#C27474', text: '#fff'},
    {char: 'k', hex: '#9FBB67', text: '#fff'},
    {char: 'l', hex: '#FFA965', text: '#fff'},
    {char: 'm', hex: '#689FB3', text: '#fff'},
    {char: 'n', hex: '#DE658D', text: '#fff'},
    {char: 'o', hex: '#D165C6', text: '#fff'},
    {char: 'p', hex: '#FF8B65', text: '#fff'},
    {char: 'q', hex: '#C2C257', text: '#fff'},
    {char: 'r', hex: '#72BBB5', text: '#fff'},
    {char: 's', hex: '#C27474', text: '#fff'}
];

// TipTap toolbar button sets, shared by TextEditor (MenuBar) and BubbleMenuBar users
export const TextEditorToolbarOptions = {
    default: ['bold', 'italic', 'underline', 'strike', 'link', 'ordered-list', 'bullet-list', 'color', 'highlight', 'clear'],
    extended: ['left', 'center', 'right', 'justify', 'size']
};

export const TextEditorColors = [
    ['#000000', '#434343', '#666666', '#999999', '#B7B7B7', '#CCCCCC', '#D9D9D9', '#EFEFEF', '#F3F3F3', '#FFFFFF'],
    ['#A4BD6D', '#FFAE65', '#6EA9B8', '#E46B8D', '#DA6BCB', '#FF8B65', '#C9C957', '#72C2BB', '#BB9767', '#C27474'],
    ['#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff']
];

